// @ts-ignore
import {States} from '@dfb/components/tooltip/constants';
import {bottom, top} from '@popperjs/core/lib/enums.d';
import {FunctionComponent, useState} from 'react';
import {usePopper} from 'react-popper';

export type TooltipPlacement = typeof top | typeof bottom;

export type TooltipProps = {
    root?: HTMLElement | null,
    isVisible?: boolean
    skidding?: number,
    distance?: number,
    placement: TooltipPlacement,
    setVisible?: (visible: boolean) => void,
    inverted?: boolean,
    closeOnClick?: boolean
};

const Tooltip: FunctionComponent<TooltipProps> = (props) => {
    const [popperElement, setPopperElement] = useState<HTMLElement | null>(null);

    const skidding = props.skidding ? props.skidding : 0;
    const distance = props.distance ? props.distance : 0;

    // for more modifiers see https://popper.js.org/docs/v2/modifiers/
    const {styles, attributes} = usePopper(props.root, popperElement, {
        placement: props.placement,
        modifiers: [{
            name: 'popperOffsets'
        }, {
            name: 'hide'
        }, {
            name: 'offset',
            options: {
                offset: [skidding, distance]
            }
        }]
    });

    let className = props.isVisible ? States.VISIBLE : '';
    className += props.inverted ? ' dfb-Tooltip--inverted' : '';

    return (
        <div ref={setPopperElement}
             className={`dfb-Tooltip dfb-Tooltip--${props.placement} ${className}`}
             style={styles.popper}
             onClick={() => {
                 if (props.closeOnClick && props.setVisible) {
                     props.setVisible(false);
                 }
             }}
             {...attributes.popper}>
            <span className="dfb-Tooltip-label" style={{width: 'max-content'}}>{props.children}</span>
        </div>
    );
};

Tooltip.defaultProps = {
    closeOnClick: true
};

export default Tooltip;
